import React from "react";

const TermsAndConditions = () => {
  return (
    <div>
      <h3>Terms and conditions</h3>
    </div>
  );
};

export default TermsAndConditions;
